
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/[tickerSymbol]/kpis",
      function () {
        return require("private-next-pages/us/[tickerSymbol]/kpis.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/[tickerSymbol]/kpis"])
      });
    }
  